<template>
  <div class="sidebar">
    <img
      src="assets/administrator/LogoMenuLight.svg"
      alt="Logo Artistic Vision"
      class="logo"
    />
    <div class="options">
      <router-link
        to="/administrator/clients"
        class="option"
        :class="{ 'active-option': isClientsRoute }"
      >
        <img
          src="assets/administrator/ClientsLight.svg"
          alt="Clientes"
          class="icon clients"
          :class="{ 'active-icon': isClientsRoute }"
        />
        <span class="option-name">Clientes</span>
      </router-link>

      <router-link
        to="/administrator/deliveries"
        class="option"
        :class="{ 'active-option': isDeliveriesRoute }"
      >
        <img
          src="assets/administrator/DeliveriesLight.svg"
          alt="Entregas"
          class="icon deliveries"
          :class="{ 'active-icon': isDeliveriesRoute }"
        />
        <span class="option-name">Entregas</span>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "SidebarMenu",
  setup() {
    const route = useRoute();

    const isClientsRoute = computed(() => {
      return (
        route.path.startsWith("/administrator/clients") ||
        route.path.startsWith("/administrator/client")
      );
    });

    const isDeliveriesRoute = computed(() => {
      return (
        route.path.startsWith("/administrator/deliveries") ||
        route.path.startsWith("/administrator/delivery")
      );
    });

    return {
      isClientsRoute,
      isDeliveriesRoute,
    };
  },
});
</script>

<style scoped lang="scss">
.sidebar {
  background-color: #073c5d;
  border-radius: 0.7rem;
  padding: 0.7rem;
  grid-column: 1/2;
  grid-row: 1/3;
  height: 100%;

  .logo {
    height: 1.5rem;
    padding-bottom: 0.5rem;
  }

  .options {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem 0rem;
    grid-row: 1/2;
    align-items: center;
  }

  .option {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    background-color: #073c5d;
    height: 3rem;
    width: 3rem;
    border-radius: 0.5rem;
    transition: all 0.3s ease;

    &.active-option {
      background-color: #0c171f !important;
    }
  }

  .option .icon {
    width: 100%;
    transition: all 0.3s ease;
    cursor: pointer;
    filter: brightness(0) saturate(100%) invert(92%) sepia(6%) saturate(392%)
      hue-rotate(169deg) brightness(93%) contrast(84%);

    &.active-icon {
      filter: brightness(0) saturate(100%) invert(76%) sepia(31%) saturate(826%)
        hue-rotate(5deg) brightness(91%) contrast(89%);
    }
  }

  .icon {
    height: 2.5rem;
  }

  .option:hover .icon:not(.active-icon) {
    filter: brightness(0) saturate(100%) invert(76%) sepia(31%) saturate(826%)
      hue-rotate(5deg) brightness(91%) contrast(89%);
  }

  .option .option-name {
    display: none;
    position: absolute;
    left: 3.5rem;
    background-color: #d3af4a;
    color: #0c171f;
    padding: 0.3rem 0.6rem;
    border-radius: 4px;
    white-space: nowrap;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    z-index: 1;
  }

  .option:hover .option-name {
    display: block;
  }
}
</style>
